import React, { useState } from "react";
import {
    TableRow,
    TableCell,
    Box,
    Typography,
    Avatar,
    Collapse
} from "@mui/material";
import CustomCheckbox from "./CustomCheckbox";
import ProjectAvatar from "./ProjectAvatar";
import ActivityBar from "./ActivityBar";
import MemberDetailsTable from "./MemberDetailsTable";
import MemberAvatar from "./MemberAvatar";

const cellStyle = {
    padding: '10px 16px',
};

// Function to get initials from name
const getInitials = (name) => {
    if (!name) return '';
    const names = name.split(' ');
    let initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
        initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }

    return initials;
};

// Function to generate a consistent color from a string
const stringToColor = (string) => {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = '#';
    for (let i = 0; i < 3; i++) {
        const value = (hash >> (i * 8)) & 0xFF;
        color += ('00' + value.toString(16)).substr(-2);
    }
    return color;
};

const MemberRow = ({ row, isSelected, onSelectToggle, isMeView = false }) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <TableRow sx={{
                '&:hover': { boxShadow: open ? 'none' : '0px 4px 20px rgba(0, 0, 0, 0.1)' },
                boxShadow: open ? '0px 16px 20px rgba(0, 0, 0, 0.3)' : 'none',
                transition: 'box-shadow 0.3s ease',
            }}>
                <TableCell sx={{
                    ...cellStyle,
                    border: 'none',
                    borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    borderLeft: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    minWidth: '32px',
                    maxWidth: '32px',
                    backgroundColor: '#fff',
                    borderRadius: open ? '10px 0 0 0px' : '10px 0 0 10px',
                }}>
                    <CustomCheckbox checked={isSelected} onChange={onSelectToggle} />
                </TableCell>
                <TableCell sx={{
                    ...cellStyle,
                    border: 'none',
                    borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    backgroundColor: '#fff',
                }}>
                    {row.id}
                </TableCell>
                <TableCell sx={{
                    ...cellStyle,
                    border: 'none',
                    borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    color: '#626262',
                    backgroundColor: '#fff',
                    textAlign: 'left'
                }}>
                    <Box
                        display="flex"
                        alignItems="center"
                        gap={1}
                        onClick={() => setOpen(!open)}
                        sx={{ cursor: "pointer" }}
                    >
                        <Avatar
                            sx={{
                                width: '40px',
                                height: '40px',
                                fontSize: '13px',
                                bgcolor: stringToColor(row.name) // Dynamic color based on name
                            }}
                        >
                            {getInitials(row.name)}
                        </Avatar>
                        <Box>
                            <Typography fontWeight="bold">{row.name}</Typography>
                            <Typography variant="body2" color="text.secondary">
                                {row.role}
                            </Typography>
                        </Box>
                    </Box>
                </TableCell>
                {!isMeView && (<TableCell sx={{
                    ...cellStyle,
                    border: 'none',
                    borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    color: '#626262',
                    backgroundColor: '#fff',
                    textAlign: 'center'
                }}>
                    <MemberAvatar items={[
                        {
                            type: 'member',
                            id: 1,
                            name: "John Doe",
                            avatar: "https://i.pravatar.cc/150?img=1",
                            code: "SG"
                        },
                        {
                            id: 2,
                            type: 'member',
                            code: "PQ",
                            avatar: "https://i.pravatar.cc/150?img=2",
                        },
                        {
                            type: 'member',
                            id: 3,
                            name: "Alice Johnson",
                            avatar: "https://i.pravatar.cc/150?img=2",
                        },
                        {
                            type: 'member',
                            id: 4,
                            name: "Alice Johnson",
                            avatar: "https://i.pravatar.cc/150?img=2",
                        }
                    ]} />
                </TableCell>)}
                <TableCell sx={{
                    ...cellStyle,
                    border: 'none',
                    borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    color: '#626262',
                    backgroundColor: '#fff',
                    textAlign: 'center'
                }}>
                    {row.time}
                </TableCell>
                <TableCell sx={{
                    ...cellStyle,
                    border: 'none',
                    borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    color: '#626262',
                    backgroundColor: '#fff',
                    textAlign: 'center'
                }}>
                    <ActivityBar activity={row.activity} />
                </TableCell>
                <TableCell sx={{
                    ...cellStyle,
                    border: 'none',
                    borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    color: '#626262',
                    backgroundColor: '#fff',
                    textAlign: 'center'
                }}>
                    -
                </TableCell>
                <TableCell sx={{
                    ...cellStyle,
                    border: 'none',
                    borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    color: '#626262',
                    backgroundColor: '#fff',
                    textAlign: 'center'
                }}>
                    {row.idle}%
                </TableCell>
                <TableCell sx={{
                    ...cellStyle,
                    border: 'none',
                    borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    color: '#626262',
                    backgroundColor: '#fff',
                    textAlign: 'center'
                }}>
                    $0.00
                </TableCell>
                <TableCell sx={{
                    ...cellStyle,
                    border: 'none',
                    borderBottom: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    borderTop: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    borderRight: open ? '1px solid rgba(0, 0, 0, 0.1)' : 'none',
                    backgroundColor: '#fff',
                    textAlign: 'center',
                    borderRadius: open ? '0px 10px 0 0px' : '0px 10px 10px 0px',
                }}>
                    <Typography color="primary" sx={{ cursor: "pointer" }}>
                        {row.notes} Notes
                    </Typography>
                </TableCell>
            </TableRow>

            <TableRow>
                <TableCell style={{
                    paddingBottom: 0,
                    paddingTop: 0,
                    paddingLeft: "0",
                    paddingRight: '0',
                    border: 'none'
                }} colSpan={10}>
                    <Collapse in={open} timeout="auto" unmountOnExit>
                        <MemberDetailsTable details={row.details} isMeView={isMeView} />
                    </Collapse>
                </TableCell>
            </TableRow>
        </>
    );
};

export default MemberRow;